import { EOtpType } from '@pages/common/SetPassword/setPassword.const';

export const IGNORE_API_URL_ERRORS = [
  '/public/recovery_password/',
  '/public/reset_password/',
  '/public/sms_send/',
  `/public/${EOtpType.SetPassEmail}/`,
  `/public/${EOtpType.ChangePassEmail}/`,
];
